// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6c1f6daa","450":"09c626db","453":"c170bccf","615":"72cdf196","788":"59c215dd","939":"ce1668a3"}[chunkId] + ".chunk.js";
};